<template>
    <div id="show">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-th-list"></i> Categories</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column is-12">
                <div class="field">
                  <label class="label">Id:</label>
                  <div class="control">
                    <span>{{item.id}}</span>
                  </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                  <label class="label">Name:</label>
                  <div class="control">
                    <span>{{item.name}}</span>
                  </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                    <label class="label">Color:</label>
                    <div class="control has-text-centered"  v-bind:style="{'backgroundColor': item.color}" style="border: 1px solid black">
                        <span>{{item.color}}</span>
                    </div>
                </div>
            </div>

            <div class="column is-12">
                <div class="field">
                    <label class="label">Text Color:</label>
                    <div class="control has-text-centered"  v-bind:style="{'backgroundColor': item.text_color}" style="border: 1px solid black">
                        <span>{{item.text_color}}</span>
                    </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                    <label class="label">Order:</label>
                    <div class="control">
                        <span>{{item.order}}</span>
                    </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                    <label class="label">Schools:</label>
                    <div class="control" v-if="!item.schools">All schools</div>
                    <div v-else class="control" v-for="school in item.schools">
                        <p>{{school.name}}</p>
                    </div>
                </div>
            </div>

            <div class="column is-2 is-offset-8 is-pulled-right"> 
                <router-link v-bind:to="{ name: 'premade-category-edit', params: { id: item.id }}" class="button is-block is-warning">
                    Edit
                </router-link>                
            </div>
            <div class="column is-2 is-pulled-right"> 
                <a href="javascript:history.go(-1)" class="button is-block">
                    Back
                </a>                
            </div>                        
        </div>          
    </div>  
</template>

<script>
import lodash from 'lodash'

export default {
  name: 'premade-categories-show',
  components: {},
  data() {
        return {
            item: {},
        }
  },
  created(){  
    this.getPremadeCategory(this.$route.params.id);
  },
  methods: {
    getPremadeCategory(id){
        this.premadeCategoryRepo.get(id).then(response => {
            this.item = response.data.data;
        });         
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/premade-categories/Show.vue